import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, CircularProgress } from '@mui/material'

const EmailSettingsTestButtons = ({
  testingSender,
  testingReceiver,
  isTestSenderDisabled,
  isTestReceiverDisabled,
  onTestSender,
  onTestReceiver
}) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Button
        variant="outlined"
        color="primary"
        disabled={isTestSenderDisabled}
        startIcon={testingSender ? <CircularProgress size={16}/> : null}
        onClick={onTestSender}
        sx={{ borderRadius: 2 }}
      >
        {testingSender ? t('mailTemplate.users.modal.testingSender') : t('mailTemplate.users.modal.testSender')}
      </Button>
      <Button
        variant="outlined"
        color="primary"
        disabled={isTestReceiverDisabled}
        startIcon={testingReceiver ? <CircularProgress size={16}/> : null}
        onClick={onTestReceiver}
        sx={{ borderRadius: 2 }}
      >
        {testingReceiver ? t('mailTemplate.users.modal.testingReceiver') : t('mailTemplate.users.modal.testReceiver')}
      </Button>
    </Box>
  )
}

export default EmailSettingsTestButtons
